// UBB-421: single-scroll anchor navigation for links that arrive via ?scrollto=<id>.
//
// WHY NOT A HASH LINK: when navigating to /products/handle#reviews from the quickview
// modal, the browser fires its native hash scroll immediately — before images, the Loop
// widget, and the Reviews.io widget have rendered. Those async elements cause layout shifts
// that leave the final scroll position wrong on mobile.
//
// HOW THIS WORKS: the quickview review-count link uses ?scrollto=<id> instead of #<id>.
// No native scroll fires. On DOMContentLoaded this module:
//   1. Reads and strips the ?scrollto= param from the URL.
//   2. Waits for window.load (images, scripts resolved) then an additional 600ms to let
//      async widgets (Reviews.io, Loop) finish their initial render — MutationObserver was
//      discarded because it fires on the widget's first child insert, before individual
//      review cards load and push content down, causing an inaccurate position measurement.
//   3. Measures the element's position at that settled point and scrolls once, offsetting
//      for any sticky/fixed header so the section isn't hidden behind it.
// Result: one smooth scroll that fires after the layout has settled.

function getStickyHeaderHeight() {
  let height = 0;
  document
    .querySelectorAll('header, [id*="shopify-section-header"]')
    .forEach((el) => {
      const pos = window.getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        height = Math.max(height, el.getBoundingClientRect().height);
      }
    });
  return height;
}

function scrollToAnchor() {
  const params = new URLSearchParams(window.location.search);
  const anchorId = params.get('scrollto');
  if (!anchorId) return;

  // Clean the URL: drop ?scrollto= only — no hash restored, as adding #id via
  // replaceState triggers a native anchor scroll in some browsers.
  params.delete('scrollto');
  const qs = params.toString();
  history.replaceState(
    null,
    '',
    window.location.pathname + (qs ? `?${qs}` : '')
  );

  const target = document.getElementById(anchorId);
  if (!target) return;

  const doScroll = () => {
    const headerOffset = getStickyHeaderHeight();
    const extraOffset = window.innerWidth >= 1024 ? 350 : 250;
    const top =
      target.getBoundingClientRect().top +
      window.scrollY -
      headerOffset -
      extraOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  // Wait for window.load then an additional 600ms for async widgets to settle
  // before measuring the element's position and scrolling.
  window.addEventListener('load', () => setTimeout(doScroll, 600), {
    once: true,
  });
}

document.addEventListener('DOMContentLoaded', scrollToAnchor);
